import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPost, apiDelete } from '../api/client.js';

export const useCertificates = (clientId) =>
  useQuery({
    queryKey: ['certificates', clientId],
    queryFn: () => apiGet(`/clients/${clientId}/certificates`),
    enabled: !!clientId,
  });

export const useRegisterCertificate = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiPost(`/clients/${clientId}/certificates`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['certificates', clientId] }),
  });
};

export const useGenerateCsr = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) => apiPost(`/clients/${clientId}/certificates/generate-csr`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['certificates', clientId] }),
  });
};

export const useCompleteCertificate = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ certId, certPem }) => apiPost(`/clients/${clientId}/certificates/${certId}/complete`, { certPem }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['certificates', clientId] }),
  });
};

export const useRevokeCertificate = (clientId) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (certId) => apiDelete(`/clients/${clientId}/certificates/${certId}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['certificates', clientId] }),
  });
};
